import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importPrivacyPolicyChangeNotice() {
    return import(
        /* webpackChunkName: "PrivacyPolicyChangeNoticeChunk" */
        './PrivacyPolicyChangeNotice'
    ).then(moduleExport => moduleExport.PrivacyPolicyChangeNotice);
}

export const privacyPolicyChangeNoticeAction = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importPrivacyPolicyChangeNotice,
        containerClassName: 'privacyPolicyChangeNoticeContainer',
    });

    return dispatch({ type: customActionType.actionType });
};
